import { useState, useEffect } from "react";

import PopupTitle from "./PopupTitle";
import InputData from "../../components/InputData";
import Dropdown from "../../components/Dropdown";
import InputSearch from "../../components/InputSearch";
import CheckBox from "../../components/CheckBox";
import ButtonIconH from "../../components/ButtonIconH";
import TooltipBox from "../../components/Tooltip";

import { post } from "../../js/post";
import { post as rpost } from "../js/api";

import {
  CALENDAR_HOURS,
  CALENDAR_MINUTES,
  EVENT_STATUS,
} from "../js/constants";

import { userData, selectedOptic } from "../../js/utils";
import { inputOnEnter } from "../../js/utils";

export default ({
  event,
  onSave,
  onCancel,
  onDelete,
  createPopupQuestion,
  removePopupQuestion,
}) => {
  const [editEvent, setEditEvent] = useState(structuredClone(event));
  const [eventCalendars, setEventCalendars] = useState([]);
  const [calendars, setCalendars] = useState([]);
  const [selectedCalendar, setSelectedCalendar] = useState(null);
  const [fullDay, setFullDay] = useState(false);
  const [hourListStart, setHourListStart] = useState(CALENDAR_HOURS);
  const [hourListEnd, setHourListEnd] = useState(CALENDAR_HOURS);
  const [minuteListEnd, setMinuteListEnd] = useState(CALENDAR_MINUTES);
  const [selectedTimeStartH, setSelectedTimeStartH] = useState(
    CALENDAR_HOURS[0],
  );
  const [selectedTimeStartM, setSelectedTimeStartM] = useState(
    CALENDAR_MINUTES[0],
  );
  const [selectedTimeEndH, setSelectedTimeEndH] = useState(CALENDAR_HOURS[0]);
  const [selectedTimeEndM, setSelectedTimeEndM] = useState(CALENDAR_MINUTES[0]);
  const [subjects, setSubjects] = useState([]);
  const [agents, setAgents] = useState([]);
  const [availability, setAvailability] = useState(true);

  const oldDateEvent = event.date;
  const oldTimeStartEvent = event.timeStart;
  const oldTimeEndEvent = event.timeEnd;

  const loadCalendars = async () => {
    const response = await rpost("agenda/ListarCalendarios.php", {
      token: userData.token,
      idUsuario: userData.id,
      idOptica: selectedOptic.id,
    });

    let cals = response.calendarios.map((cal) => {
      const c = {
        id: cal.id,
        name: cal.nombre,
        color: cal.color,
        visible: cal.visible,
        minTime: parseInt(cal.horaInicio.split(":")[0]),
        maxTime: parseInt(cal.horaFin.split(":")[0]),
        users: [],
        iCanEdit: false,
      };
      c.users = cal.usuarios.map((user) => {
        return {
          id: user.id,
          name: user.nombre,
          lastName: user.apellidos,
          readOnly: user.soloLectura,
          pic: null,
        };
      });
      return c;
    });

    cals.forEach((cal) => {
      const user = cal.users.find((u) => {
        return u.id === userData.id;
      });
      if (user) {
        cal.iCanEdit = !user.readOnly;
      }
    });

    cals = cals.filter((c) => {
      return c.iCanEdit;
    });

    const eCals = cals.map((c) => {
      return {
        id: c.id,
        text: c.name,
      };
    });

    setCalendars(cals);
    setEventCalendars(eCals);
    const ev = structuredClone(editEvent);
    if (event.calendarId === -1) {
      setSelectedCalendar(cals[0]);
      ev.calendarId = cals[0].id;
      setEditEvent(ev);
      buildTimeDropdowns(cals[0], ev);

      checkDateTimeAvailability(
        cals[0].id,
        event.date,
        event.timeStart,
        event.timeEnd,
      );
    } else {
      const pos = cals.findIndex((c) => {
        return c.id === event.calendarId;
      });
      if (pos >= 0) {
        setSelectedCalendar(cals[pos]);
        buildTimeDropdowns(cals[pos], ev);
      }
    }
  };

  const loadSubjects = async () => {
    const response = await rpost("agenda/ListarAsuntosEventos.php", {
      token: userData.token,
    });

    const s = response.map((item) => {
      return {
        id: item,
        text: item,
      };
    });
    setSubjects(s);
  };

  const loadAgents = async () => {
    const response = await post("ListarProfesionales.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });

    const ags = response.map((item) => {
      return {
        id: item.nombre + " " + item.apellidos,
        text: item.nombre + " " + item.apellidos,
      };
    });

    ags.sort((a, b) => a.text.localeCompare(b.text));

    ags.unshift({
      id: "",
      text: "",
    });

    setAgents(ags);
  };

  const buildTimeStart = (ev) => {
    ev.timeStart = selectedTimeStartH.text + ":" + selectedTimeStartM.text;
  };

  const buildTimeEnd = (ev) => {
    ev.timeEnd = selectedTimeEndH.text + ":" + selectedTimeEndM.text;
  };

  const buildTimeDropdowns = (selCalendar, ev) => {
    const hoursLS = [];
    Array.from(
      { length: selCalendar.maxTime - 1 - selCalendar.minTime + 1 },
      (_, i) => selCalendar.minTime + i,
    ).map((num) => {
      const time = num < 10 ? "0" + num.toString() : num.toString();
      hoursLS.push({ id: time, text: time });
    });
    setHourListStart(hoursLS);
    const hoursLE = [];
    Array.from(
      { length: selCalendar.maxTime - selCalendar.minTime + 1 },
      (_, i) => selCalendar.minTime + i,
    ).map((num) => {
      const time = num < 10 ? "0" + num.toString() : num.toString();
      hoursLE.push({ id: time, text: time });
    });
    setHourListEnd(hoursLE);
    if (!fullDay) {
      if (
        ev.timeStart < hoursLS[0].text + ":00" ||
        ev.timeStart > hoursLS[hoursLS.length - 1].text + ":45"
      ) {
        setSelectedTimeStartH(hoursLS[0]);
        setSelectedTimeStartM(CALENDAR_MINUTES[0]);
        ev.timeStart = hoursLS[0].text + ":" + CALENDAR_MINUTES[0].text;
      }
      if (
        ev.timeEnd < hoursLS[0].text + ":00" ||
        ev.timeEnd > hoursLE[hoursLE.length - 1].text + ":00"
      ) {
        setSelectedTimeEndH(hoursLE[0]);
        setSelectedTimeEndM(CALENDAR_MINUTES[0]);
        ev.timeEnd = hoursLE[0].text + ":" + CALENDAR_MINUTES[0].text;
      }
      setEditEvent(ev);
    }
  };

  const onChangeTitle = (e) => {
    const ev = structuredClone(editEvent);
    ev.title = e;
    setEditEvent(ev);
  };

  const onChangeStatus = (e) => {
    const ev = structuredClone(editEvent);
    ev.status = e.id;
    setEditEvent(ev);
  };

  const onChangeCalendar = (e) => {
    const cal = calendars.find((c) => {
      return c.id === e.id;
    });
    if (cal) {
      const ev = structuredClone(editEvent);
      ev.calendarId = cal.id;
      ev.visible = cal.visible;
      ev.calendarColor = cal.color;
      setEditEvent(ev);
      setSelectedCalendar(cal);
      buildTimeDropdowns(cal, ev);
      checkDateTimeAvailability(
        cal.id,
        editEvent.date,
        selectedTimeStartH.text + ":" + selectedTimeStartM.text + ":00",
        selectedTimeEndH.text + ":" + selectedTimeEndM.text + ":00",
      );
    }
  };

  const onSelectPatient = (e) => {
    const ev = structuredClone(editEvent);
    ev.patient.id = e.idPaciente;
    ev.patient.name = e.nombre;
    ev.patient.lastName = e.apellidos;
    ev.patient.pic = e.fotoPaciente;
    ev.patient.phone = e.telefono;
    setEditEvent(ev);
  };

  const onChangePatient = (e) => {
    const ev = structuredClone(editEvent);
    ev.patient.id = -1;
    ev.patient.name = e;
    ev.patient.lastName = "";
    ev.patient.pic = null;
    ev.patient.phone = "";
    setEditEvent(ev);
  };

  const loadLastPatient = () => {
    const patient = JSON.parse(localStorage.getItem("lastUser"));
    if (patient) {
      const ev = structuredClone(editEvent);
      ev.patient.id = patient.id;
      ev.patient.name = patient.name;
      ev.patient.lastName = patient.lastName;
      ev.patient.pic = null;
      ev.patient.phone = patient.phone;
      setEditEvent(ev);
    }
  };

  const onSelectAgent = (e) => {
    const ev = structuredClone(editEvent);
    ev.agent = e.text;
    setEditEvent(ev);
  };

  const onChangeDate = (e) => {
    const ev = structuredClone(editEvent);
    ev.date = e.target.value;
    setEditEvent(ev);
    checkDateTimeAvailability(
      selectedCalendar.id,
      e.target.value,
      selectedTimeStartH.text + ":" + selectedTimeStartM.text + ":00",
      selectedTimeEndH.text + ":" + selectedTimeEndM.text + ":00",
    );
  };

  const onClickFullDay = () => {
    const ev = structuredClone(editEvent);
    if (!fullDay) {
      ev.timeStart = -1;
      ev.timeEnd = -1;
    } else {
      buildTimeStart(ev);
      buildTimeEnd(ev);
    }
    setEditEvent(ev);
    setFullDay(!fullDay);
  };

  const calculateEndFromStart = (ev) => {
    if (ev.timeStart !== -1) {
      let endH = parseInt(selectedTimeStartH.text) + 1;
      endH = endH < 10 ? "0" + endH.toString() : endH.toString();
      const end = endH + ":" + selectedTimeStartM;
      const endC =
        selectedCalendar.maxTime < 10
          ? "0" + selectedCalendar.maxTime.toString() + ":00"
          : selectedCalendar.maxTime.toString() + ":00";
      if (end <= endC) {
        setSelectedTimeEndH({ id: endH, text: endH });
        setSelectedTimeEndM({
          id: selectedTimeStartM.id,
          text: selectedTimeStartM.text,
        });
        ev.timeEnd = end;
      }
    }
  };

  const checkDateTimeAvailability = async (
    calendarId,
    date,
    timeStart,
    timeEnd,
  ) => {
    const response = await rpost("agenda/ComprobarDisponibilidadEvento.php", {
      token: userData.token,
      idUsuario: userData.id,
      idCalendario: calendarId,
      fecha: date,
      horaInicio: timeStart,
      horaFin: timeEnd,
      idEventoSeleccionado: editEvent.id,
    });
    setAvailability(response.disponible);
  };

  const onChangeStartTimeH = (e) => {
    setSelectedTimeStartH(e);
    checkDateTimeAvailability(
      selectedCalendar.id,
      editEvent.date,
      e.text + ":" + selectedTimeStartM.text + ":00",
      selectedTimeEndH.text + ":" + selectedTimeEndM.text + ":00",
    );
  };

  const onChangeStartTimeM = (e) => {
    setSelectedTimeStartM(e);
    checkDateTimeAvailability(
      selectedCalendar.id,
      editEvent.date,
      selectedTimeStartH.text + ":" + e.text + ":00",
      selectedTimeEndH.text + ":" + selectedTimeEndM.text + ":00",
    );
  };

  const onChangeEndTimeH = (e) => {
    setSelectedTimeEndH(e);
    checkDateTimeAvailability(
      selectedCalendar.id,
      editEvent.date,
      selectedTimeStartH.text + ":" + selectedTimeStartM.text + ":00",
      e.text + ":" + selectedTimeEndM.text + ":00",
    );
  };

  const onChangeEndTimeM = (e) => {
    setSelectedTimeEndM(e);
    checkDateTimeAvailability(
      selectedCalendar.id,
      editEvent.date,
      selectedTimeStartH.text + ":" + selectedTimeStartM.text + ":00",
      selectedTimeEndH.text + ":" + e.text,
    );
  };

  const onChangeSubject = (e) => {
    const ev = structuredClone(editEvent);
    ev.subject = e.text;
    setEditEvent(ev);
  };

  const saveEvent = () => {
    if (editEvent.subject.trim() === "") {
      createPopupQuestion(
        "Debe rellenar un título para la cita.",
        removePopupQuestion,
        null,
        "Cerrar",
        "",
      );
      return;
    }
    if (editEvent.calendarId === -1) {
      createPopupQuestion(
        "Debe seleccionar un calendario.",
        removePopupQuestion,
        null,
        "Cerrar",
        "",
      );
      return;
    }
    if (
      editEvent.timeStart !== -1 &&
      editEvent.timeEnd <= editEvent.timeStart
    ) {
      createPopupQuestion(
        "La hora de finalización no puede ser menor a la hora de inicio.",
        removePopupQuestion,
        null,
        "Cerrar",
        "",
      );
      return;
    }

    if (editEvent.periodic) {
      if (
        editEvent.periodicityEnd &&
        editEvent.periodicityEndType === "RepetirFecha" &&
        editEvent.periodicityEndTypeDate < editEvent.date
      ) {
        createPopupQuestion(
          "La fecha de finalización periódica no puede ser menor a la fecha de inicio.",
          removePopupQuestion,
          null,
          "Cerrar",
          "",
        );
        return;
      }
      if (
        editEvent.periodicityEnd &&
        editEvent.periodicityEndType === "RepetirNumero" &&
        (editEvent.periodicityNumberRepetitions.trim() === "" ||
          parseInt(editEvent.periodicityNumberRepetitions) < 1)
      ) {
        createPopupQuestion(
          "Debe introducir un número de repeticiones de cita válido.",
          removePopupQuestion,
          null,
          "Cerrar",
          "",
        );
        return;
      }
      if (editEvent.periodicId === -1) {
        savePeriodicEvent("Todos");
      } else {
        createPopupQuestion(
          "La cita periódica ha sido modificada. ¿A qué repeticiones se debería aplicar?",
          () => savePeriodicEvent("Todos"),
          () => savePeriodicEvent("Esta"),
          "A todas",
          "Sólo a ésta",
          //() => savePeriodicEvent("Siguientes"),
          //"A ésta y siguientes",
          removePopupQuestion,
          "Cancelar",
        );
      }
    } else {
      saveNormalEvent();
    }
  };

  const saveNormalEvent = async () => {
    const patient =
      editEvent.patient != null
        ? {
            id: editEvent.patient.id === -1 ? "" : editEvent.patient.id,
            nombre: editEvent.patient.name,
            apellidos: editEvent.patient.lastName,
          }
        : {
            id: "",
            nombre: "",
            apellidos: "",
          };

    await rpost("agenda/GuardarEvento.php", {
      token: userData.token,
      idUsuario: userData.id,
      idEvento: editEvent.id,
      idCalendario: editEvent.calendarId,
      nombre: editEvent.title,
      asunto: editEvent.subject,
      estado: editEvent.status,
      profesional: editEvent.agent,
      fecha: editEvent.date,
      horaInicio: editEvent.timeStart,
      horaFinal: editEvent.timeEnd,
      paciente: patient,
      idOptica: selectedOptic.id,
    });

    onSave(editEvent);
  };

  const savePeriodicEvent = async (type) => {
    const patient =
      editEvent.patient != null
        ? {
            id: editEvent.patient.id === -1 ? "" : editEvent.patient.id,
            nombre: editEvent.patient.name,
            apellidos: editEvent.patient.lastName,
          }
        : {
            id: "",
            nombre: "",
            apellidos: "",
          };

    let periodicityEndTypeDate = "";
    let periodicityEndNumberRepetitions = -1;
    if (editEvent.periodicityEnd) {
      if (editEvent.periodicityEndType === "RepetirFecha") {
        periodicityEndTypeDate = editEvent.periodicityEndTypeDate;
      } else {
        periodicityEndNumberRepetitions =
          editEvent.periodicityNumberRepetitions;
      }
    }

    switch (type) {
      case "Todos":
        if (editEvent.id !== -1) {
          await rpost(
            "agenda/EliminarEventoPeriodicoExcepcionDesdeEventoPeriodico.php",
            {
              token: userData.token,
              idEventoPeriodico: editEvent.id,
              fecha: "",
              hora: -1,
            },
          );
        }
        await rpost("agenda/GuardarEventoPeriodico.php", {
          token: userData.token,
          idUsuario: userData.id,
          idEvento: editEvent.id,
          idCalendario: editEvent.calendarId,
          nombre: editEvent.title,
          asunto: editEvent.subject,
          profesional: editEvent.agent,
          fecha: editEvent.date,
          horaInicio: editEvent.timeStart,
          horaFinal: editEvent.timeEnd,
          paciente: patient,
          tipo: editEvent.periodicity,
          accionFestivo: editEvent.periodicityOnHolidays,
          fechaFinRepeticion: periodicityEndTypeDate,
          numRepeticiones: periodicityEndNumberRepetitions,
          idOptica: selectedOptic.id,
        });
        break;
      case "Esta":
        await rpost("agenda/GuardarEventoPeriodicoExcepcion.php", {
          token: userData.token,
          idEventoPeriodicoExcepcion: editEvent.periodicityExceptionId,
          idEventoPeriodico: editEvent.periodicId,
          tipo: "Edicion",
          nombre: editEvent.title,
          asunto: editEvent.subject,
          profesional: editEvent.agent,
          fechaAntigua: oldDateEvent,
          horaInicioAntigua: oldTimeStartEvent,
          horaFinalAntigua: oldTimeEndEvent,
          fechaNueva: editEvent.date,
          horaInicioNueva: editEvent.timeStart,
          horaFinalNueva: editEvent.timeEnd,
          paciente: patient,
          aplicableSoloEsteEvento: true,
          aplicableDesdeEsteEvento: false,
        });
        break;
      /*case "Siguientes":
        await rpost(
          "agenda/EliminarEventoPeriodicoExcepcionDesdeEventoPeriodico.php",
          {
            token: userData.token,
            idEventoPeriodico: editEvent.id,
            fecha: editEvent.date,
            hora: editEvent.timeStart,
          }
        );
        await rpost("agenda/GuardarEventoPeriodicoExcepcion.php", {
          token: userData.token,
          idEventoPeriodicoExcepcion: -1,
          idEventoPeriodico: editEvent.periodicId,
          tipo: "Edicion",
          nombre: editEvent.title,
          asunto: editEvent.subject,
          profesional: editEvent.agent,
          fechaAntigua: oldDateEvent,
          horaInicioAntigua: oldTimeStartEvent,
          horaFinalAntigua: oldTimeEndEvent,
          fechaNueva: editEvent.date,
          horaInicioNueva: editEvent.timeStart,
          horaFinalNueva: editEvent.timeEnd,
          paciente: patient,
          aplicableSoloEsteEvento: false,
          aplicableDesdeEsteEvento: true,
        });
        break;*/
    }

    onSave(editEvent);
  };

  const deleteEvent = () => {
    if (editEvent.periodic) {
      createPopupQuestion(
        "La cita periódica va a ser eliminada. ¿A qué repeticiones se debería aplicar?",
        () => deletePeriodicEvent("Todos"),
        () => deletePeriodicEvent("Esta"),
        "A todas",
        "Sólo a ésta",
        removePopupQuestion,
        "Cancelar",
      );
    } else {
      createPopupQuestion(
        "¿Desea eliminar la cita " + editEvent.title + "?",
        deleteNormalEvent,
        removePopupQuestion,
        "Eliminar",
        "Cancelar",
      );
    }
  };

  const deleteNormalEvent = async () => {
    await rpost("agenda/EliminarEvento.php", {
      token: userData.token,
      idUsuario: userData.id,
      idEvento: editEvent.id,
    });
    removePopupQuestion();
    onDelete(editEvent);
  };

  const deletePeriodicEvent = async (type) => {
    switch (type) {
      case "Todos":
        await rpost("agenda/EliminarEventoPeriodico.php", {
          token: userData.token,
          idEventoPeriodico: editEvent.periodicId,
        });
        break;
      case "Esta":
        const patient =
          editEvent.patient != null
            ? {
                id: editEvent.patient.id === -1 ? "" : editEvent.patient.id,
                nombre: editEvent.patient.name,
                apellidos: editEvent.patient.lastName,
              }
            : {
                id: "",
                nombre: "",
                apellidos: "",
              };

        /*if (editEvent.periodicityExceptionId !== -1) {
          await rpost("agenda/EliminarEventoPeriodicoExcepcion.php", {
            token: userData.token,
            idEventoPeriodicoExcepcion: editEvent.periodicityExceptionId,
          });
        }*/
        await rpost("agenda/GuardarEventoPeriodicoExcepcion.php", {
          token: userData.token,
          idEventoPeriodicoExcepcion: editEvent.periodicityExceptionId,
          idEventoPeriodico: editEvent.periodicId,
          tipo: "Eliminacion",
          nombre: editEvent.title,
          asunto: editEvent.subject,
          profesional: editEvent.agent,
          fechaAntigua: oldDateEvent,
          horaInicioAntigua: oldTimeStartEvent,
          horaFinalAntigua: oldTimeEndEvent,
          fechaNueva: editEvent.date,
          horaInicioNueva: editEvent.timeStart,
          horaFinalNueva: editEvent.timeEnd,
          paciente: patient,
          aplicableSoloEsteEvento: true,
          aplicableDesdeEsteEvento: false,
        });
        break;
    }

    removePopupQuestion();
    onDelete(editEvent);
  };

  const onClickPeriodic = () => {
    const ev = structuredClone(editEvent);
    ev.periodic = !ev.periodic;
    setEditEvent(ev);
  };

  const onChangePeriodicity = (option) => {
    const ev = structuredClone(editEvent);
    ev.periodicity = option;
    setEditEvent(ev);
  };

  const onChangeDateHolidaysOption = (e) => {
    const ev = structuredClone(editEvent);
    ev.periodicityOnHolidays = e.id;
    setEditEvent(ev);
  };

  const onClickIsPeriodic = () => {
    const ev = structuredClone(editEvent);
    ev.periodicityEnd = !ev.periodicityEnd;
    setEditEvent(ev);
  };

  const onChangePeriodicityEndType = (option) => {
    const ev = structuredClone(editEvent);
    ev.periodicityEndType = option;
    setEditEvent(ev);
  };

  const onChangePeriodicityEndTypeDate = (e) => {
    const ev = structuredClone(editEvent);
    ev.periodicityEndTypeDate = e.target.value;
    setEditEvent(ev);
  };

  const onChangePeriodicityEndTypeNumber = (e) => {
    const ev = structuredClone(editEvent);
    ev.periodicityNumberRepetitions = e;
    setEditEvent(ev);
  };

  useEffect(() => {
    if (event != null) {
      setFullDay(event.timeStart === -1);
      if (event.timeStart === -1) {
        setSelectedTimeStartH({ id: "09", text: "09" });
        setSelectedTimeStartM({ id: "00", text: "00" });
        setSelectedTimeEndH({ id: "10", text: "10" });
        setSelectedTimeEndM({ id: "00", text: "00" });
      } else {
        const tokensS = event.timeStart.split(":");
        const tokensE = event.timeEnd.split(":");
        setSelectedTimeStartH({ id: tokensS[0], text: tokensS[0] });
        setSelectedTimeStartM({ id: tokensS[1], text: tokensS[1] });
        setSelectedTimeEndH({ id: tokensE[0], text: tokensE[0] });
        setSelectedTimeEndM({ id: tokensE[1], text: tokensE[1] });
      }

      loadCalendars();
      loadAgents();
      loadSubjects();
    }
  }, [event]);

  useEffect(() => {
    if (selectedCalendar) {
      const ev = structuredClone(editEvent);
      buildTimeStart(ev);
      calculateEndFromStart(ev);
      setEditEvent(ev);
    }
  }, [selectedTimeStartH]);

  useEffect(() => {
    if (selectedCalendar) {
      const ev = structuredClone(editEvent);
      buildTimeStart(ev);
      calculateEndFromStart(ev);
      setEditEvent(ev);
    }
  }, [selectedTimeStartM]);

  useEffect(() => {
    if (selectedCalendar) {
      if (parseInt(selectedTimeEndH.text) === selectedCalendar.maxTime) {
        setMinuteListEnd([{ id: "00", text: "00" }]);
        setSelectedTimeEndM({ id: "00", text: "00" });
      } else {
        setMinuteListEnd(CALENDAR_MINUTES);
      }
      const ev = structuredClone(editEvent);
      buildTimeEnd(ev);
      setEditEvent(ev);
    }
  }, [selectedTimeEndH]);

  useEffect(() => {
    if (selectedCalendar) {
      const ev = structuredClone(editEvent);
      buildTimeEnd(ev);
      setEditEvent(ev);
    }
  }, [selectedTimeEndM]);

  return (
    <div className="popup-container secondary popup-calendar-event">
      <div className="popup-message">
        <div className="popup-calendario">
          <PopupTitle
            title={`${editEvent.id === -1 ? "Crear" : "Editar"} cita`}
            onClose={onCancel}
          />
        </div>
        <div className="popup-calendar-body">
          <div className="popup-calendar-contenido">
            <div className="popup-calendar-contenido-element">
              <div className="label calendar-popup-label">Calendario</div>
              <Dropdown
                id="calendar-types"
                tabIndex={201}
                optionList={eventCalendars}
                size={1}
                op={editEvent.calendarId}
                onChange={onChangeCalendar}
              />
            </div>
            <div className="popup-calendar-contenido-element">
              <div className="label calendar-popup-label">Título</div>
              <Dropdown
                id="calendar-types"
                tabIndex={202}
                optionList={subjects}
                size={1}
                op={editEvent.subject}
                onChange={onChangeSubject}
                mandatory={false}
              />
            </div>
            <div className="popup-calendar-contenido-element">
              <div className="label calendar-popup-label">Observaciones</div>
              <InputData
                maxLength={100}
                inactive={false}
                type="type-alphanum"
                size={0}
                input={editEvent.title}
                onChange={onChangeTitle}
                tabIndex={203}
              />
            </div>
            <div className="popup-calendar-contenido-element">
              <div className="label calendar-popup-label">Agente</div>
              <Dropdown
                id="calendar-types"
                tabIndex={204}
                optionList={agents}
                size={1}
                op={editEvent.agent}
                onChange={onSelectAgent}
              />
            </div>
            <div className="popup-calendar-contenido-element">
              <div className="label calendar-popup-label">Paciente</div>
              <InputSearch
                id="contactonombre"
                tabIndex={205}
                type="type-alpha"
                size={2}
                op={
                  editEvent.patient.id === -1
                    ? editEvent.patient.name
                    : editEvent.patient.name + " " + editEvent.patient.lastName
                }
                onSelect={onSelectPatient}
                showCode={false}
                onChange={onChangePatient}
              />
              <button className="cell-icon" onClick={() => loadLastPatient()}>
                <img
                  src="/images/support-extra/patient.svg"
                  loading="lazy"
                  alt="Icon"
                  className="cell-icon"
                  data-tooltip-id="tt-calendar-patient"
                  tabIndex={206}
                ></img>
                <TooltipBox
                  id="tt-calendar-patient"
                  content={
                    <div className="cell">Último paciente consultado</div>
                  }
                ></TooltipBox>
              </button>
            </div>
            <div className="popup-calendar-contenido-element">
              <div className="label calendar-popup-label">Teléfono</div>
              <span className="edit-event-phone">
                {editEvent.patient.phone}
              </span>
            </div>
            <div className="popup-calendar-contenido-element">
              <div className="label calendar-popup-label">Fecha</div>
              <input
                type="date"
                tabIndex={207}
                className="input-field"
                value={editEvent.date}
                onChange={onChangeDate}
                onKeyUp={(e) => inputOnEnter(e)}
              />
              <div className="data-field c-pointer" onClick={onClickFullDay}>
                <CheckBox tabIndex={208} active={fullDay} onClick={() => {}} />
                <span className="label">Día completo</span>
              </div>
            </div>
            {!fullDay && (
              <div className="popup-calendar-contenido-element">
                <div className="label calendar-popup-label">Hora</div>
                <div className="popup-event-times">
                  <Dropdown
                    id="calendar-types"
                    tabIndex={209}
                    optionList={hourListStart}
                    size={1}
                    op={selectedTimeStartH.id}
                    onChange={onChangeStartTimeH}
                  />
                  <span>:</span>
                  <Dropdown
                    id="calendar-types"
                    tabIndex={210}
                    optionList={CALENDAR_MINUTES}
                    size={1}
                    op={selectedTimeStartM.id}
                    onChange={onChangeStartTimeM}
                  />
                  <span>-</span>
                  <Dropdown
                    id="calendar-types"
                    tabIndex={211}
                    optionList={hourListEnd}
                    size={1}
                    op={selectedTimeEndH.id}
                    onChange={onChangeEndTimeH}
                  />
                  <span>:</span>
                  <Dropdown
                    id="calendar-types"
                    tabIndex={212}
                    optionList={minuteListEnd}
                    size={1}
                    op={selectedTimeEndM.id}
                    onChange={onChangeEndTimeM}
                  />
                </div>
              </div>
            )}
            {editEvent.timeStart !== -1 &&
              editEvent.timeEnd !== -1 &&
              !availability && (
                <div className="label popup-info error">
                  Ya existen citas programadas para esa hora y para ese
                  calendario.
                </div>
              )}
            <div className="popup-calendar-contenido-element">
              <div className="label calendar-popup-label">Estado</div>
              <Dropdown
                id="calendar-status"
                tabIndex={213}
                optionList={EVENT_STATUS}
                size={1}
                op={editEvent.status}
                onChange={onChangeStatus}
                mandatory={true}
              />
            </div>
            {/*<div className="data-field c-pointer" onClick={onClickPeriodic}>
              <CheckBox
                tabIndex={212}
                active={editEvent.periodic}
                onClick={() => {}}
              />
              <span className="label periodic-date">Es una cita periódica</span>
            </div>
            {editEvent.periodic && (
              <div className="popup-periodicity">
                <div className="popup-calendar-contenido-element">
                  <div className="label">Periodicidad</div>
                </div>
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-compressed">
                  <div className="radio-ops-container">
                    <div className="radio-op">
                      <RadioButton
                        tabIndex={213}
                        active={editEvent.periodicity === "Diario"}
                        onClick={() => onChangePeriodicity("Diario")}
                      />
                      <span className="label">
                        Repetir esta cita todos los días
                      </span>
                    </div>
                  </div>
                </div>
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-compressed">
                  <div className="radio-ops-container">
                    <div className="radio-op">
                      <RadioButton
                        tabIndex={214}
                        active={editEvent.periodicity === "Semanal"}
                        onClick={() => onChangePeriodicity("Semanal")}
                      />
                      <span className="label">
                        Repetir esta cita todos los{" "}
                        {dayNumberToName(
                          moment(editEvent.date).format("E"),
                          true,
                          true,
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-compressed">
                  <div className="radio-ops-container">
                    <div className="radio-op">
                      <RadioButton
                        tabIndex={215}
                        active={editEvent.periodicity === "Mensual"}
                        onClick={() => onChangePeriodicity("Mensual")}
                      />
                      <span className="label">
                        Repetir esta cita todos los días{" "}
                        {moment(editEvent.date).format("DD")} de cada mes
                      </span>
                    </div>
                  </div>
                </div>
                <div className="popup-calendar-contenido-element popup-calendar-contenido-element-compressed">
                  <div className="radio-ops-container">
                    <div className="radio-op">
                      <RadioButton
                        tabIndex={216}
                        active={editEvent.periodicity === "Anual"}
                        onClick={() => onChangePeriodicity("Anual")}
                      />
                      <span className="label">
                        Repetir esta cita todos los{" "}
                        {moment(editEvent.date).format("DD")} de{" "}
                        {monthNumberToName(
                          moment(editEvent.date).format("MM"),
                          true,
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="popup-calendar-contenido-element cita-festivo">
                  <div className="label">Si la cita cae en festivo</div>
                  <Dropdown
                    id="calendar-types"
                    tabIndex={217}
                    optionList={DATE_HOLIDAYS_OPTIONS}
                    size={1}
                    op={editEvent.periodicityOnHolidays}
                    onChange={onChangeDateHolidaysOption}
                  />
                </div>
                <div
                  className="data-field c-pointer"
                  onClick={onClickIsPeriodic}
                >
                  <CheckBox
                    tabIndex={218}
                    active={editEvent.periodicityEnd}
                    onClick={() => {}}
                  />
                  <span className="label">Indicar fin de periodicidad</span>
                </div>
                {editEvent.periodicityEnd && (
                  <div className="popup-calendar-contenido-element popup-calendar-contenido-element-compressed">
                    <div className="radio-ops-container">
                      <div className="radio-op">
                        <RadioButton
                          tabIndex={219}
                          active={
                            editEvent.periodicityEndType === "RepetirFecha"
                          }
                          onClick={() =>
                            onChangePeriodicityEndType("RepetirFecha")
                          }
                        />
                        <span className="label">Repetir hasta la fecha</span>
                      </div>
                    </div>
                    <input
                      type="date"
                      tabIndex={220}
                      className="input-field"
                      value={
                        editEvent.periodicityEndTypeDate === ""
                          ? moment().format("YYYY-MM-DD")
                          : editEvent.periodicityEndTypeDate
                      }
                      onChange={onChangePeriodicityEndTypeDate}
                      onKeyUp={(e) => inputOnEnter(e)}
                    />
                  </div>
                )}
                {editEvent.periodicityEnd && (
                  <div className="popup-calendar-contenido-element popup-calendar-contenido-element-compressed">
                    <div className="radio-ops-container">
                      <div className="radio-op">
                        <RadioButton
                          tabIndex={221}
                          active={
                            editEvent.periodicityEndType === "RepetirNumero"
                          }
                          onClick={() =>
                            onChangePeriodicityEndType("RepetirNumero")
                          }
                        />
                        <span className="label">Núm. repeticiones</span>
                      </div>
                    </div>
                    <InputData
                      id="text3"
                      type="type-only-numbers"
                      input={editEvent.periodicityNumberRepetitions}
                      onChange={(e) => onChangePeriodicityEndTypeNumber(e)}
                      tabIndex={222}
                    />
                  </div>
                )}
              </div>
            )}*/}
          </div>
          <div className="popup-row-buttons-container">
            <div className="popup-row-buttons">
              <ButtonIconH
                text="Eliminar"
                disabled={editEvent.id === -1}
                onClick={editEvent.id !== -1 ? () => deleteEvent() : null}
              />
              <ButtonIconH text="Cancelar" onClick={onCancel} />
              <ButtonIconH text="Guardar" onClick={saveEvent} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
